import React, { SetStateAction, useState, Dispatch } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import {
    makeStyles,
    createStyles,
    withStyles,
    WithStyles,
} from '@material-ui/core/styles';

import axios from 'axios';
import { useHistory } from 'react-router-dom';

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';

import { COLORS } from './Theme';
import { SIcon } from './Icon';

import {
    member as v_member,
    oper as v_oper,
    basic,
    Values,
} from '../request/values';
import { IconButton } from '@material-ui/core';
import { useCookies } from 'react-cookie';
import DialogConfirm from './Dialog';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    paper: {
        // marginTop: theme.spacing(8),
        paddingTop: '13vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
            paddingTop: '0',
        },
    },
    title: {
        width: '100%',
        alignItems: 'left',
        '& img': {
            width: '45vw',
        },
        [theme.breakpoints.up('md')]: {
            width: '80%',
            '& img': {
                width: '80%',
            },
        },
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            width: '80%',
        },
    },
    submit: {
        height: 60,
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        // backgroundColor: `${COLORS.WHITE}`,
        // color: `${COLORS.WATER_BLUE}`,
    },
    logoSection: {
        // position: 'absolute',
        // bottom: '5vh',
        // width: '100vw',
        // textAlign: 'center'
        display: 'flex',
        justifyContent: 'center',
        flex: 1,
        alignItems: 'flex-end',
        marginTop: '30vh',
        [theme.breakpoints.up('md')]: {
            marginTop: '15vh',
        },
    },
    input: {
        ...theme.typography.subtitle1,
    },
    inputLabel: {
        ...theme.typography.body1,
        color: '#000',
    },
    desc: {
        ...theme.typography.h1,
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h5,
        },
    },
    iconButtonPadding: {
        paddingLeft: 0,
        [theme.breakpoints.up('md')]: {
            paddingLeft: '43px',
        },
    },
}));

const ClassEnter: React.FC<any> = (props) => {
    const classes = useStyles();

    const [classCode, setClassCode] = useState<string>('');
    const [logoutDialog, setLogoutDialog] = useState<boolean>(false);
    const [classVersion, setClassVersion] = useState<Number>(1);
    let history = useHistory();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [cookies, setCookie, removeCookie] = useCookies();
    const { member, setMember, deleteMember } = props;
    const [label, setLabel] = useState('모두 접속할 때까지 기다려 주세요.');

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        setClassCode(value);
    };

    const logout = () => {
        removeCookie('access');
        deleteMember();
        history.push('/');
    };

    const handleLogoutOpen = () => {
        setLogoutDialog(true);
    };

    const handleClose = () => {
        setLogoutDialog((prevState) => !prevState);
    };

    const handleFocus = () => {
        setLabel('클래스 코드');
    };

    const handleBlur = () => {
        if (classCode === '') {
            setLabel('모두 접속할 때까지 기다려 주세요.');
        }
    };

    const handleButton = async () => {
        console.log('click button');
        let url;
        if (member.type === 'oper') {
            url = SERVER + v_oper.oper + v_oper.class_enter;
        } else if (member.type === undefined || member.type === 'member') {
            url = SERVER + v_member.member + v_member.class_enter;
        }

        let response = await axios({
            method: 'POST',
            data: {
                classCode: classCode,
                email: member.id,
            },
            withCredentials: true,
            url: url,
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    setClassVersion(data.class_version);
                    // setMember()
                    // setMember(Object.assign(member, {classCode : classCode}));
                    // let m = member;
                    // m.classCode = classCode
                    // console.log('before setMember', member)
                    // setMember(Object.assign(member, {classCode : classCode}))

                    // history.push({
                    //     pathname: '/CompanyAction',
                    // });
                    return data;
                } else {
                    console.log('data code? ', data.code);
                    console.log('not start code? ', Values.CLASS_NO_START_CODE);
                    console.log(
                        'data code === start code? ',
                        data.code === Values.CLASS_NO_START_CODE
                    );
                    if (data.code === Values.CLASS_NO_START_CODE) {
                        enqueueSnackbar(ToastStr.CLASS_NOT_STARTED_STR, {
                            variant: 'warning',
                            translate: 'no',
                        });
                    } else if (data.code === Values.CLASS_FINISH_CODE) {
                        enqueueSnackbar(ToastStr.CLASS_ALREADY_END_STR, {
                            variant: 'warning',
                            translate: 'no',
                        });
                    } else if (data.code == Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.CLASS_ENTER_FAIL, {
                            variant: 'warning',
                            translate: 'no',
                        });
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                            variant: 'error',
                            translate: 'no',
                        });
                    }
                    return data;
                }
            });

        console.log('response : ', response);
        if (response.code == Values.SUCCESS_CODE) {
            console.log('before setMember', member);
            let m = JSON.parse(JSON.stringify(member));
            m['classCode'] = classCode;

            console.log('is same?', m === member, m, member);

            if (member.type === 'oper') {
                setMember(
                    Object.assign(m, { classVersion: response.class_version })
                );
                history.push({
                    pathname: '/',
                });
            } else if (member.type === undefined || member.type === 'member') {
                setMember(
                    Object.assign(m, {
                        companyNum: 0,
                        classVersion: response.class_version,
                    })
                );
                history.push({
                    pathname: '/CompanyAction',
                });
            }
        }
    };

    return (
        <>
            <div className={classes.paper}>
                <div style={{ width: '100%' }}>
                    <IconButton
                        className={classes.iconButtonPadding}
                        onClick={() => handleLogoutOpen()}
                    >
                        <img
                            src="/images/logout.webp"
                            style={{ width: '6vw', maxWidth: '40px' }}
                        />
                    </IconButton>
                </div>
                <div className={classes.title}>
                    <img src="/images/logo.webp" />
                </div>

                <div className={classes.form}>
                    <TextField
                        variant="standard"
                        margin="normal"
                        required
                        fullWidth
                        id="classCode"
                        label={label}
                        name="classCode"
                        autoComplete="classCode"
                        autoFocus
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        InputProps={{ classes: { input: classes.input } }}
                        InputLabelProps={{
                            classes: { root: classes.inputLabel },
                        }}
                        value={classCode}
                        onChange={valueChangeHandler}
                        style={{ color: `${COLORS.CHARCOAL_GREY}` }}
                    />
                    <Typography
                        className={classes.desc}
                        style={{ fontFamily: 'NanumR' }}
                    >
                        선생님께서 안내해주신, 클래스 코드가 필요합니다.
                    </Typography>
                    <Button
                        fullWidth
                        className={classes.submit}
                        onClick={handleButton}
                    >
                        <Typography
                            variant="h3"
                            style={{
                                color: `${COLORS.WATER_BLUE}`,
                                fontFamily: 'NanumR',
                                fontWeight: 'bold',
                            }}
                        >
                            접속하기
                        </Typography>
                    </Button>
                </div>
            </div>
            <div className={classes.logoSection}>
                <SIcon type="P" />
            </div>

            <DialogConfirm
                open={logoutDialog}
                handleClose={() => handleClose()}
                title={'로그아웃 하시겠습니까?'}
                context={''}
                yesText="네"
                noText="아니오"
                yesConfirm={() => logout()}
                noConfirm={() => handleClose()}
            />
        </>
    );
};

export default ClassEnter;
